document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".banner-swiper", {
    loop: true, // Carrusel infinito
    autoplay: {
      delay: 3000, // Tiempo entre cambios de imagen (3s)
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    grabCursor: true,
    slidesPerView: 1,
    touchEventsTarget: "container",
    touchRatio: 1,
    touchAngle: 45,
    threshold: 5,
  });
});
